import { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import AadharCard from "../../Components/Services/Aadhaar";
import DrivingLicense from "../../Components/Services/Driving";
import PanCard from "../../Components/Services/Pancard";
import RegistrationCertificate from "../../Components/Services/Registration";
import VoterCard from "../../Components/Services/VoterCard";
import axios from "axios";
import ChasisToRC from "../../Components/Services/ChasisToRC";
import RcToMobile from "../../Components/Services/RcToMobile";
import Challan from "../../Components/Services/Challan";
import RCMasked from "../../Components/Services/RCMasked";
import FindPan from "../../Components/Services/FindPan";
import PuccCertificate from "../../Components/Services/components/pan/PuccCertificate";

export default function ServicesPage() {
  const [selectedService, setSelectedService] = useState(null);
  const [access, setAccess] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/access-check `,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setAccess(response.data?.serviceAccess);
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };
  const services = [
    {
      title: "Chasis To RC",
      component: ChasisToRC,
      slug: "ChasisToRC",
      show:
        access?.includes("smartrc_chassis") ||
        access?.includes("parivaanrc_chassis") ||
        access?.includes("parivaanrc2_chassis") ||
        access?.includes("digilockerrc_chassis"),
      rcTypes: [
        ...(access?.includes("smartrc_chassis") ? ["smartrc_chassis"] : []),
        ...(access?.includes("parivaanrc_chassis")
          ? ["parivaanrc_chassis"]
          : []),
        ...(access?.includes("parivaanrc2_chassis")
          ? ["parivaanrc2_chassis"]
          : []),
        ...(access?.includes("digilockerrc_chassis")
          ? ["digilockerrc_chassis"]
          : []),
      ],
    },
    {
      title: "Registration Certificate",
      component: RegistrationCertificate,
      slug: "rc",
      show:
        access?.includes("smartrc") ||
        access?.includes("parivaanrc") ||
        access?.includes("parivaanrc2") ||
        access?.includes("digilockerrc"),
      rcTypes: [
        ...(access?.includes("smartrc") ? ["smartrc"] : []),
        ...(access?.includes("parivaanrc") ? ["parivaanrc"] : []),
        ...(access?.includes("parivaanrc2") ? ["parivaanrc2"] : []),
        ...(access?.includes("digilockerrc") ? ["digilockerrc"] : []),
      ],
    },
    {
      title: "RC Lite",
      component: RCMasked,
      slug: "rclite",
      show:
        access?.includes("smartrclite") ||
        access?.includes("parivaanrclite") ||
        access?.includes("parivaanrc2lite") ||
        access?.includes("digilockerrclite"),
      rcTypes: [
        ...(access?.includes("smartrclite") ? ["smartrclite"] : []),
        ...(access?.includes("parivaanrclite") ? ["parivaanrclite"] : []),
        ...(access?.includes("parivaanrc2lite") ? ["parivaanrc2lite"] : []),
        ...(access?.includes("digilockerrclite") ? ["digilockerrclite"] : []),
      ],
    },
    // {
    //   title: "Authorized RC (not yet completed)",
    //   component: RCMasked,
    //   slug: "rclite",
    //   show:
    //     access?.includes("smartrclite") ||
    //     access?.includes("parivaanrclite") ||
    //     access?.includes("parivaanrc2lite") ||
    //     access?.includes("digilockerrclite"),
    //   rcTypes: [
    //     ...(access?.includes("smartrclite") ? ["smartrclite"] : []),
    //     ...(access?.includes("parivaanrclite") ? ["parivaanrclite"] : []),
    //     ...(access?.includes("parivaanrc2lite") ? ["parivaanrc2lite"] : []),
    //     ...(access?.includes("digilockerrclite") ? ["digilockerrclite"] : []),
    //   ],
    // },
    {
      title: "RC to Mobile No.",
      component: RcToMobile,
      slug: "rctomobile",
      show: access?.includes("rc_mobile"),
    },
    {
      title: "Challan",
      component: Challan,
      slug: "challan",
      show: access?.includes("challan"),
    },
    {
      title: "Download PAN Card",
      component: PanCard,
      slug: "pan",
      show: access?.includes("pan"),
    },
    {
      title: "Driving License",
      component: DrivingLicense,
      slug: "dl",
      show: access?.includes("drivingLicense"),
    },
    {
      title: "Aadhaar Card",
      component: AadharCard,
      slug: "aadhaar",
      show: access?.includes("aadhaar"),
    },
    {
      title: " Download Voter Card",
      component: VoterCard,
      slug: "voter",
      show: access?.includes("voterId"),
    },
    {
      title: "Find PAN",
      component: FindPan,
      slug: "findpan",
      show: access?.includes("findpan"),
    },
    {
      title: "PUCC Certificate",
      component: PuccCertificate,
      slug: "PUCC",
      show: access?.includes("PUCC"),
    },
  ].filter((service) => service.show);

  const handleSelect = (slug) => {
    setSelectedService(slug);
  };

  const SelectedComponent = selectedService
    ? services.find((s) => s.slug === selectedService)?.component
    : null;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold p-2">Services</h1>

      {SelectedComponent ? (
        <div className="bg-white p-6 rounded-md shadow-md">
          <button
            className="text-sm text-blue-600 underline"
            onClick={() => setSelectedService(null)}
          >
            ← Back to all services
          </button>
          <SelectedComponent />
        </div>
      ) : (
        <section className="p-6 grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
          {services.map((service, idx) => (
            <div
              key={idx}
              onClick={() => handleSelect(service.slug)}
              className="rounded-xl border p-4 shadow-sm hover:border-blue-600 cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="bg-purple-100 p-2 rounded-full">
                  <FileText className="text-blue-600" />
                </div>
                <div>
                  <h3 className="font-bold text-xl">{service.title}</h3>
                  <p className="text-sm text-gray-500">
                    Select the service to get started
                  </p>
                </div>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(service.slug);
                }}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md text-sm flex items-center gap-2 hover:bg-purple-600"
              >
                <Download size={16} /> Select
              </button>
            </div>
          ))}
        </section>
      )}
    </div>
  );
}

// import { useEffect, useState } from "react";
// import { FileText, Download } from "lucide-react";
// import { toast } from "react-toastify";
// import AadharCard from "../../Components/Services/Aadhaar";
// import DrivingLicense from "../../Components/Services/Driving";
// import PanCard from "../../Components/Services/Pancard";
// import RegistrationCertificate from "../../Components/Services/Registration";
// import VoterCard from "../../Components/Services/VoterCard";
// import axios from "axios";
// import ChasisToRC from "../../Components/Services/ChasisToRC";
// import RcToMobile from "../../Components/Services/RcToMobile";
// import Challan from "../../Components/Services/Challan";
// import RCMasked from "../../Components/Services/RCMasked";
// import FindPan from "../../Components/Services/FindPan";
// import PuccCertificate from "../../Components/Services/components/pan/PuccCertificate";

// export default function ServicesPage() {
//   const [selectedService, setSelectedService] = useState(null);
//   const [access, setAccess] = useState([]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/services/access-check `,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );
//       setAccess(response.data?.serviceAccess);
//     } catch (e) {
//       console.error("Error fetching data:", e);
//     }
//   };

//   // Handle PUCC Certificate redirect
//   const handlePuccRedirect = async () => {
//     try {
//       // Show loading toast
//       const toastId = toast.loading(
//         "🔄 Redirecting you to WhatsApp. Please wait...",
//         {
//           position: "top-right",
//           autoClose: false,
//         },
//       );

//       // Wait for 2 seconds
//       await new Promise((resolve) => setTimeout(resolve, 2000));

//       // Dismiss loading toast
//       toast.dismiss(toastId);

//       // Show success toast
//       toast.success("Opening WhatsApp...", {
//         position: "top-right",
//         autoClose: 2000,
//       });

//       // WhatsApp number
//       const whatsappPhone = "+919124578108";
//       const whatsappUrl = `https://wa.me/${whatsappPhone.replace(/\D/g, "")}?text=Hello,%20I%20need%20PUCC%20Certificate%20assistance.`;

//       // Open WhatsApp
//       setTimeout(() => {
//         window.open(whatsappUrl, "_blank");
//       }, 500);
//     } catch (error) {
//       toast.error("Failed to redirect. Please try again.", {
//         position: "top-right",
//         autoClose: 3000,
//       });
//       console.error("WhatsApp redirect error:", error);
//     }
//   };

//   const services = [
//     {
//       title: "Chasis To RC",
//       component: ChasisToRC,
//       slug: "ChasisToRC",
//       show:
//         access?.includes("smartrc_chassis") ||
//         access?.includes("parivaanrc_chassis") ||
//         access?.includes("parivaanrc2_chassis") ||
//         access?.includes("digilockerrc_chassis"),
//       rcTypes: [
//         ...(access?.includes("smartrc_chassis") ? ["smartrc_chassis"] : []),
//         ...(access?.includes("parivaanrc_chassis")
//           ? ["parivaanrc_chassis"]
//           : []),
//         ...(access?.includes("parivaanrc2_chassis")
//           ? ["parivaanrc2_chassis"]
//           : []),
//         ...(access?.includes("digilockerrc_chassis")
//           ? ["digilockerrc_chassis"]
//           : []),
//       ],
//     },
//     {
//       title: "Registration Certificate",
//       component: RegistrationCertificate,
//       slug: "rc",
//       show:
//         access?.includes("smartrc") ||
//         access?.includes("parivaanrc") ||
//         access?.includes("parivaanrc2") ||
//         access?.includes("digilockerrc"),
//       rcTypes: [
//         ...(access?.includes("smartrc") ? ["smartrc"] : []),
//         ...(access?.includes("parivaanrc") ? ["parivaanrc"] : []),
//         ...(access?.includes("parivaanrc2") ? ["parivaanrc2"] : []),
//         ...(access?.includes("digilockerrc") ? ["digilockerrc"] : []),
//       ],
//     },
//     {
//       title: "RC Lite",
//       component: RCMasked,
//       slug: "rclite",
//       show:
//         access?.includes("smartrclite") ||
//         access?.includes("parivaanrclite") ||
//         access?.includes("parivaanrc2lite") ||
//         access?.includes("digilockerrclite"),
//       rcTypes: [
//         ...(access?.includes("smartrclite") ? ["smartrclite"] : []),
//         ...(access?.includes("parivaanrclite") ? ["parivaanrclite"] : []),
//         ...(access?.includes("parivaanrc2lite") ? ["parivaanrc2lite"] : []),
//         ...(access?.includes("digilockerrclite") ? ["digilockerrclite"] : []),
//       ],
//     },
//     {
//       title: "RC to Mobile No.",
//       component: RcToMobile,
//       slug: "rctomobile",
//       show: access?.includes("rc_mobile"),
//     },
//     {
//       title: "Challan",
//       component: Challan,
//       slug: "challan",
//       show: access?.includes("challan"),
//     },
//     {
//       title: "Download PAN Card",
//       component: PanCard,
//       slug: "pan",
//       show: access?.includes("pan"),
//     },
//     {
//       title: "Driving License",
//       component: DrivingLicense,
//       slug: "dl",
//       show: access?.includes("drivingLicense"),
//     },
//     {
//       title: "Aadhaar Card",
//       component: AadharCard,
//       slug: "aadhaar",
//       show: access?.includes("aadhaar"),
//     },
//     {
//       title: " Download Voter Card",
//       component: VoterCard,
//       slug: "voter",
//       show: access?.includes("voterId"),
//     },
//     {
//       title: "Find PAN",
//       component: FindPan,
//       slug: "findpan",
//       show: access?.includes("findpan"),
//     },
//     {
//       title: "PUCC Certificate",
//       component: PuccCertificate,
//       slug: "pucc",
//       show: access?.includes("pucc"),
//       isDirectRedirect: true, // Flag for direct redirect
//     },
//   ].filter((service) => service.show);

//   const handleSelect = async (slug) => {
//     // Check if this is a direct redirect service (PUCC)
//     const service = services.find((s) => s.slug === slug);
//     if (service?.isDirectRedirect) {
//       await handlePuccRedirect();
//     } else {
//       setSelectedService(slug);
//     }
//   };

//   const SelectedComponent = selectedService
//     ? services.find((s) => s.slug === selectedService)?.component
//     : null;

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <h1 className="text-2xl font-bold p-2">Services</h1>

//       {SelectedComponent ? (
//         <div className="bg-white p-6 rounded-md shadow-md">
//           <button
//             className="text-sm text-blue-600 underline"
//             onClick={() => setSelectedService(null)}
//           >
//             ← Back to all services
//           </button>
//           <SelectedComponent />
//         </div>
//       ) : (
//         <section className="p-6 grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
//           {services.map((service, idx) => (
//             <div
//               key={idx}
//               onClick={() => handleSelect(service.slug)}
//               className="rounded-xl border p-4 shadow-sm hover:border-blue-600 cursor-pointer"
//             >
//               <div className="flex items-center gap-4">
//                 <div className="bg-purple-100 p-2 rounded-full">
//                   <FileText className="text-blue-600" />
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-xl">{service.title}</h3>
//                   <p className="text-sm text-gray-500">
//                     Select the service to get started
//                   </p>
//                 </div>
//               </div>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleSelect(service.slug);
//                 }}
//                 className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md text-sm flex items-center gap-2 hover:bg-purple-600"
//               >
//                 <Download size={16} /> Select
//               </button>
//             </div>
//           ))}
//         </section>
//       )}
//     </div>
//   );
// }
